import React, { Fragment } from 'react';
import queryString from 'query-string'
import { layout } from 'styled-system';
import Form from 'antd/lib/form';
import AntdFormItem from 'antd/lib/form/FormItem';
import Modal from 'antd/lib/modal';
import Select from 'antd/lib/select';
import AntInput from 'antd/lib/input';
import notification from 'antd/lib/notification';
import { Spin } from 'antd';
import Axios from 'axios';
import styled, { css } from 'styled-components';
import { withRouter } from 'react-router-dom';

import { APIHOST } from '../../config';
import { Flex, Box, ResponsiveFlex } from '../../components/Flex';
import { Text } from '../../components/Text';
import referralIllustration from '../../images/referral-illustration.png';
import PhoneInput from '../../components/PhoneInput';
import ReferralTerms from '../../components/referralTerms';

const Option = Select.Option;

const Input = styled(AntInput)`
  ${layout}
`;
const FormItem = styled(AntdFormItem)`
  margin-bottom: 8px;
  & .ant-form-item-label label {
    color: #666;
    font-weight: 600;
  }

  & .ant-form-item-required:before {
    // remove the red '*' required symbol
    display: none;
  }

  & .ant-form-item-label label:after {
    // remove the ':' after the field label
    display: none;
  }
`;

const Button = styled.button`
  background: #0D8CE6;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16109);
  border-radius: 4px;
  border: none;
  color: white;
  height: 54px;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  cursor: pointer;
  ${(props) =>
    props.loading &&
    css`
      pointer-events: none;
      opacity: 0.8;
      &:after {
        content: '...';
      }
  `}
  ${(props) => props.disabled && css`
    color: rgba(0,0,0,.25);
    background: #f7f7f7;
    border-color: #d9d9d9;
    pointer-events: none;
    box-shadow: none;
`}
`;

const HighlightText = styled.span`
  color: #EB6DB9;
  font-weight: 700;
`;

const TermsButton = styled(Text)`
  cursor: pointer;
`;

class ReferralSignup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refererName: '',
      phoneNumber: '',
      regionNumber: '',
      phoneNumberValidateStatus: true,
      isSubmitting: false,
      email: '',
      showTerms: false,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { referralCode } = this.props.match.params;
    this.getReferrer(referralCode);

    const query = queryString.parse(location.search);
    const { name, region_number: regionNumber = '', phone = '', email } = query;
    this.setState({ name, phoneNumber: phone, email, regionNumber });
  }

  getReferrer(referralCode) {
    const config = {
      method: 'get',
      url: `${APIHOST}/v2/invitation/referrers?referral_code=${referralCode}`,
    };
    Axios(config)
      .then((response) => {
        const { name } = response.data;

        this.setState({ refererName: name });
      })
      .catch((e) => {
        window.location = 'https://www.workstream.us/get-started';
      });
  }

  handleSubmit() {
    const { form } = this.props;
    form.validateFields((err, values) => {
      let phoneNumberError;
      // check phone number
      const { phoneNumberValidateStatus, phoneNumber, regionNumber } = this.state;
      if (phoneNumberValidateStatus === false || !phoneNumber) {
        phoneNumberError = true;
        this.setState({
          phoneNumberErrorMsg: 'Please enter a correct phone number.',
          phoneNumberValidateStatus: false,
        });
      }
      
      if (err || phoneNumberError) {
        return;
      }

      const config = {
        method: 'post',
        url: `${APIHOST}/v2/invitation/referees/`,
        data: {
          referee: {
            ...values,
            region_number: `+${regionNumber}`,
            phone: phoneNumber,
            referrer_code: this.state.referralCode,
          }
        },
      };
      this.setState({ isSubmitting: true });
      Axios(config)
        .then((response) => {
          this.setState({
            isSubmitting: false,
            phoneNumber: '',
            regionNumber: '',
          });
          this.props.form.resetFields();
          notification.success({
            message: 'Schedule success',
            description: 'Our sales representative will contact you shortly!',
          });
          setTimeout(() => {
            window.location = 'https://bit.ly/3mxOaf4';
          }, 2000);
        })
        .catch((err) => {
          this.setState({ isSubmitting: false });
          let errorMessage = 'Please contact help@workstream.is for details.';
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          }
          notification.error({
            message: 'Something went wrong',
            description: errorMessage,
          });
        });
    });
  }

  updatePhoneNumber(status, value, countryData) {
    const regionNumber = countryData.dialCode;
    let phoneNumber = value;

    if (status === false) {
      this.setState({
        phoneNumberErrorMsg: 'Please enter a correct phone number.',
        phoneNumberValidateStatus: false,
      });
    } else {
      this.setState({
        phoneNumberErrorMsg: '',
        phoneNumberValidateStatus: true,
      });
    }

    if (phoneNumber.indexOf('+') !== -1) {
      phoneNumber = phoneNumber.replace(`+${regionNumber}`, '');
    }

    this.setState({
      phoneNumber,
      regionNumber,
    });
  }

  render() {
    const { refererName } = this.state;

    if (refererName === '') {
      return (
        <Flex style={{ height: '100vh' }} alignItems="center" justifyContent="center">
          <Spin size="large" />
        </Flex>
      )    
    }

    const { getFieldDecorator } = this.props.form;
    const helloText = this.state.name ? `Hello ${this.state.name}!` : 'Hello!'
    getFieldDecorator('referral_code', { initialValue: this.props.match.params.referralCode });

    return (
      <Flex flexDirection="column" alignItems="center">
        <ReferralTerms showTerms={this.state.showTerms} onCancel={() => this.setState({ showTerms: false })} />
        <Flex
          my={[0, 87]}
          height={['auto']}
          boxShadow={['none', '0px 2px 14px rgba(13, 140, 230, 0.0962692)']}
          borderRadius={[0, '5px']}
          bg="white"
          justifyContent="center"
          width={['100%', '863px']}
        > 
          <ResponsiveFlex flex={[0, 1]} display={['none', 'flex']} justifyContent="center" alignItems="center" bg="#FFFAFF" borderRight={1} borderRightStyle="solid" borderRightColor="#F2F2F2">
            <Flex column alignItems="center" px={5}>
              <img src={referralIllustration} role="presentation" width={193} />
              <Text bold fontSize="22px" mb={1}>{helloText}</Text>
              <Text fontSize="18px" textAlign="center">
                <span>{this.state.refererName} invited you to try Workstream.&nbsp;</span>
                <HighlightText>You'll get a $200 Amazon gift card when you sign up for service! *</HighlightText>
              </Text>
              <Box mt={3} py={15} px={25} width={1} borderRadius="3px" border={1} borderColor="#DEE1EC" borderStyle="solid">
                <Text bold fontSize="14px" mb={2} textAlign="center">With Workstream you also get:</Text>
                <Text fontSize="14px" textAlign="center">• Text recruiting tools for you business.</Text>
                <Text fontSize="14px" textAlign="center">• Better Applicants</Text>
                <Text fontSize="14px" textAlign="center">• Virtual Interviews</Text>
                <Text fontSize="14px" textAlign="center">• Reduce Ghosting</Text>
              </Box>
              <Text fontSize="13px" pt={15} color="#959595">* After a new customer completes their first billing cycle, both parties will receive a $200 Amazon Gift Card. <TermsButton onClick={() => this.setState({ showTerms: true })}>Terms and Condition.</TermsButton></Text>
            </Flex>
          </ResponsiveFlex>
          {/* Form part */}
          <Flex flex={1} justifyContent="center" alignItems="center" column pt={[34, 62]} pb={[34, 62]}>
            <Flex flexDirection="column" width="280px">
              <Box pb={[34]}>
                <Text bold fontSize="22px">Welcome to Workstream!</Text>
                <Text fontSize="17px" color="#959595">We are happy to see you here</Text>
              </Box>
              <FormItem label="Name">
                {getFieldDecorator('name', {
                  initialValue: this.state.name,
                  rules: [{ required: true, message: 'Please input your name.' }],
                })(<Input size="large" />)}
              </FormItem>
              <FormItem label="Company name">
                {getFieldDecorator('company_name', {
                  rules: [{ required: true, message: 'Please input your company name.' }],
                })(<Input size="large" />)}
              </FormItem>
              <FormItem
                label="Cell phone"
                help={this.state.phoneNumberErrorMsg || ''}
                validateStatus={this.state.phoneNumberValidateStatus === false ? 'error' : ''}
              >
                <PhoneInput
                  style={{ width: '100%' }}
                  defaultValue={this.state.regionNumber + this.state.phoneNumber}
                  onPhoneNumberChange={this.updatePhoneNumber.bind(this)}
                  preferredCountries={['us', 'sg', 'ca']}
                  inputClassName="ant-input ant-input-lg"
                ></PhoneInput>
              </FormItem>
              <FormItem label="Email">
                {getFieldDecorator('email', {
                  initialValue: this.state.email,
                  rules: [
                    { required: true, message: 'Please input your email.' },
                    { type: 'email', message: 'Please input a valid email.' },
                  ],
                })(<Input size="large" />)}
              </FormItem>
              <Flex alignItems="flex-start" justifyContent="flex-start">
                <FormItem label="Total employees">
                  {getFieldDecorator('number_of_employees', {
                    rules: [{ required: true, message: 'Please select.' }],
                  })(
                    <Select style={{ width: 130 }}>
                      <Option value="1-24">1-24</Option>
                      <Option value="25-49">25-49</Option>
                      <Option value="50-99">50-99</Option>
                      <Option value="100-499">100-499</Option>
                      <Option value="500-999">500-999</Option>
                      <Option value="1000-2499">1000-2499</Option>
                      <Option value="2500-4999">2500-4999</Option>
                      <Option value="5000+">5000+</Option>
                    </Select>
                  )}
                </FormItem>
                <Box ml={20} />
                <FormItem label="New hires per year">
                  {getFieldDecorator('number_of_hires_each_year', {
                    rules: [{ required: true, message: 'Please select.' }],
                  })(
                    <Select style={{ width: 130 }}>
                      <Option value="1-24">1-24</Option>
                      <Option value="25-49">25-49</Option>
                      <Option value="50-99">50-99</Option>
                      <Option value="100-499">100-499</Option>
                      <Option value="500-999">500-999</Option>
                      <Option value="1000-2499">1000-2499</Option>
                      <Option value="2500-4999">2500-4999</Option>
                      <Option value="5000+">5000+</Option>
                    </Select>
                  )}
                </FormItem>
              </Flex>
              <Box mt={28} />
              <Button
                onClick={this.handleSubmit.bind(this)}
                loading={this.state.isSubmitting}
              >
                Schedule a demo
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export default withRouter(Form.create()(ReferralSignup));
